import React, { ComponentType } from 'react';
import { ScreenReaderAnnouncerProvider } from '@components/common/accessibility';

/**
 * Higher-order component that wraps a component with the ScreenReaderAnnouncerProvider
 * This enables screen reader announcements for accessibility
 *
 * @param Component The component to wrap
 * @returns A new component wrapped with ScreenReaderAnnouncerProvider
 */
export function withScreenReaderAnnouncements<P extends object>(Component: ComponentType<P>): ComponentType<P> {
  const ComponentWithScreenReaderAnnouncements = (props: P) => (
    <ScreenReaderAnnouncerProvider>
      <Component {...props} />
    </ScreenReaderAnnouncerProvider>
  );

  // Set display name for easier debugging
  const displayName = Component.displayName || Component.name || 'Component';
  ComponentWithScreenReaderAnnouncements.displayName = `withScreenReaderAnnouncements(${displayName})`;

  return ComponentWithScreenReaderAnnouncements;
}
